import { NavigationRowStateType, } from '@kubit/web-ui-components/navigationRow/types';
import { navigationRowCommonStyles } from '../commonStyles';
import { KubitNavigationRowSizeType, KubitNavigationRowVariantType } from '../variants';
export const getRegularAltStyles = (FOUNDATIONS, FONT) => {
    return {
        [KubitNavigationRowSizeType.SMALL]: {},
        [KubitNavigationRowVariantType.REGULAR_ALT]: {
            [NavigationRowStateType.DEFAULT]: {
                ...navigationRowCommonStyles(FOUNDATIONS, FONT),
            },
            [NavigationRowStateType.HOVER]: {
                ...navigationRowCommonStyles(FOUNDATIONS, FONT),
                container: {
                    ...navigationRowCommonStyles(FOUNDATIONS, FONT).container,
                    background_color: FOUNDATIONS.color_accent_hover_primary_bg_100,
                },
            },
            [NavigationRowStateType.PRESSED]: {
                ...navigationRowCommonStyles(FOUNDATIONS, FONT),
                container: {
                    ...navigationRowCommonStyles(FOUNDATIONS, FONT).container,
                    background_color: FOUNDATIONS.color_accent_pressed_primary_bg_200,
                },
            },
            [NavigationRowStateType.DISABLED]: {
                ...navigationRowCommonStyles(FOUNDATIONS, FONT),
                container: {
                    ...navigationRowCommonStyles(FOUNDATIONS, FONT).container,
                    background_color: FOUNDATIONS.color_accent_disabled_bg_100,
                    cursor: 'auto',
                },
                decorativeElementContainer: {
                    ...navigationRowCommonStyles(FOUNDATIONS, FONT).decorativeElementContainer,
                    firstChild: {
                        ...navigationRowCommonStyles(FOUNDATIONS, FONT)?.decorativeElementContainer?.firstChild,
                        background_color: FOUNDATIONS.color_accent_disabled_icon_100,
                    },
                },
                arrowIcon: {
                    ...navigationRowCommonStyles(FOUNDATIONS, FONT).arrowIcon,
                    color: FOUNDATIONS.color_accent_disabled_icon_100,
                },
            },
        },
    };
};
//# sourceMappingURL=regularAlt.js.map